import { twMerge } from '@stereoagency/tailwind-config';
import React from 'react';
import { Body, Heading } from '../../atoms';
export default function StepCard(param) {
    var label = param.label, title = param.title, description = param.description, className = param.className;
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge(className, 'p-7 rounded-xl bg-bg-subtle')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-5"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        as: "div",
        variant: "h2",
        className: "text-red-700"
    }, typeof label === 'number' ? "".concat(label, ".") : label)), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, title)), !!description && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
        className: "prose"
    }, description))));
}

//# sourceMappingURL=StepCard.js.map